// @flow
import * as React from 'react';
import { type CategoryLink } from '../../types/CategoryLink';
import classNames from 'classnames';
import DiscoveryTags from '../DiscoveryTags/DiscoveryTags';
import { getSimilarItemsUrl } from '../../utils/urls';
import isEqual from 'react-fast-compare';
import { type ItemFacets } from '../../types/ItemFacets';
import ItemGrid from '../../components/ItemCard/ItemGrid';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './SimilarItems.module.scss';

type Props = $ReadOnly<{|
    categoryLinks: CategoryLink[],
    centerHeader: boolean,
    className: string,
    facets: ItemFacets,
    headerMessage: React.Node,
    itemTitle: string,
    linkMessage: React.Node,
    similarItems: any[],
    suggestions: any[],
    width: number,
|}>;

const SimilarItems = (props: Props) => {
    const {
        categoryLinks,
        centerHeader = false,
        className = '',
        facets,
        headerMessage,
        itemTitle,
        linkMessage,
        similarItems,
        suggestions,
        width,
    } = props;
    const cardViewModels = similarItems.length ? similarItems : new Array(6).fill(null);
    const classes = classNames(styles['similar-items'], className);
    const gridHeaderClasses = classNames(styles['similar-items-header'], { [styles['center-text']]: centerHeader });
    const similarItemsUrl = getSimilarItemsUrl(itemTitle);
    return (
        <div className={classes}>
            <div key="header" className={gridHeaderClasses}>
                <h2 className={styles['header-text-large']}>{headerMessage}</h2>
                <Link route to={similarItemsUrl}>
                    {linkMessage}
                </Link>
            </div>
            <DiscoveryTags
                key="discoveryTags"
                categoryLinks={categoryLinks}
                facets={facets}
                suggestions={suggestions}
                width={width}
            />
            <ItemGrid
                cardViewModels={cardViewModels}
                hideSeller
                hideLotNumbers
                className={styles['similar-grid']}
                itemCardClass={styles['similar-cards']}
                key="grid"
            />
        </div>
    );
};

export default React.memo<Props>(SimilarItems, isEqual);
